"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _pickToolTipName = _interopRequireDefault(require("./UIAvatarDisplay/pickToolTipName"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIAvatar = _interopRequireDefault(require("./UIAvatar"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: inline-flex !important;\n  height: 32px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUIAvatarTag = (0, _styledComponents.default)(_UITag.default).withConfig({
  displayName: "UIAvatarTag__StyledUIAvatarTag",
  componentId: "sc-9mbv9s-0"
})(_templateObject());

var UIAvatarTag =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UIAvatarTag, _Component);

  function UIAvatarTag() {
    (0, _classCallCheck2.default)(this, UIAvatarTag);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAvatarTag).apply(this, arguments));
  }

  (0, _createClass2.default)(UIAvatarTag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          avatarLookup = _this$props.avatarLookup,
          children = _this$props.children,
          className = _this$props.className,
          companyId = _this$props.companyId,
          displayName = _this$props.displayName,
          domain = _this$props.domain,
          email = _this$props.email,
          fetchAvatars = _this$props.fetchAvatars,
          hubSpotUserEmail = _this$props.hubSpotUserEmail,
          lookup = _this$props.lookup,
          type = _this$props.type,
          vid = _this$props.vid,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["avatarLookup", "children", "className", "companyId", "displayName", "domain", "email", "fetchAvatars", "hubSpotUserEmail", "lookup", "type", "vid"]);
      var lookupUnProxy = lookup || avatarLookup || {};

      if (avatarLookup) {
        _devLogger.default.warn({
          message: 'UIAvtarTag avatarLookup prop is depreciated, please just use supply props directly or use lookup instead'
        });
      }

      return _react.default.createElement(StyledUIAvatarTag, (0, _extends2.default)({}, rest, {
        _avatar: _react.default.createElement(_UIAvatar.default, {
          lookup: lookup || avatarLookup,
          companyId: companyId,
          email: email,
          domain: domain,
          displayName: displayName,
          fetchAvatars: fetchAvatars,
          hubSpotUserEmail: hubSpotUserEmail,
          vid: vid,
          type: type,
          size: 'xs',
          className: 'm-right-1'
        }),
        className: className
      }), children || (0, _pickToolTipName.default)(lookupUnProxy) || displayName);
    }
  }]);
  return UIAvatarTag;
}(_react.Component);

UIAvatarTag.defaultProps = (0, _extends2.default)({}, _UITag.default.defaultProps);
UIAvatarTag.propTypes = (0, _extends2.default)({}, _UITag.default.propTypes, {
  className: _react.PropTypes.string,
  children: _react.PropTypes.node,
  displayName: _react.PropTypes.string,
  companyId: _react.PropTypes.number,
  email: _react.PropTypes.string,
  domain: _react.PropTypes.string,
  type: _react.PropTypes.string,
  avatarLookup: _react.PropTypes.object,
  lookup: function lookup(props, propName) {
    if (props[propName] && props[propName].length > 1) {
      return new Error('Only one lookup per UIAvatarTag for the moment Please 😥');
    }

    return null;
  }
});
var _default = UIAvatarTag;
exports.default = _default;
module.exports = exports.default;